import { render, staticRenderFns } from "./ChatRichText.vue?vue&type=template&id=af9bbdaa&scoped=true"
import script from "./ChatRichText.vue?vue&type=script&lang=js"
export * from "./ChatRichText.vue?vue&type=script&lang=js"
import style0 from "./ChatRichText.vue?vue&type=style&index=0&id=af9bbdaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9bbdaa",
  null
  
)

export default component.exports